import { type FC } from 'react';
import { useAuthStore } from '@/stores/auth.store';

interface HeaderProps {
  onLogout: () => void;
  onToggleSidebar?: () => void;
}

export const Header: FC<HeaderProps> = ({ onLogout, onToggleSidebar }) => {
  const user = useAuthStore((s) => s.user);

  return (
    <header
      style={{
        height: 'var(--header-height)',
        backgroundColor: 'var(--color-surface)',
        borderBottom: '1px solid var(--color-border)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--spacing-md)',
        gap: 'var(--spacing-sm)',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--spacing-md)',
          minWidth: 0,
        }}
      >
        {onToggleSidebar && (
          <button
            className="hamburger-btn"
            onClick={onToggleSidebar}
            title="Menu"
            style={{
              width: 40,
              height: 40,
              display: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'transparent',
              border: 'none',
              color: 'var(--color-text)',
              fontSize: 20,
              borderRadius: 'var(--radius-md)',
              cursor: 'pointer',
            }}
            aria-label="Ouvrir le menu"
          >
            ☰
          </button>
        )}
        <h1
          style={{
            fontSize: 'var(--font-size-lg)',
            fontWeight: 700,
            color: 'var(--color-primary)',
            whiteSpace: 'nowrap',
          }}
        >
          StratMap
        </h1>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--spacing-md)',
          minWidth: 0,
        }}
      >
        {user && (
          <span
            className="header-username"
            style={{
              fontSize: 'var(--font-size-sm)',
              color: 'var(--color-text-muted)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: 200,
            }}
          >
            {user.firstName} {user.lastName}
          </span>
        )}
        <button
          onClick={onLogout}
          style={{
            padding: '6px 12px',
            backgroundColor: 'transparent',
            color: 'var(--color-text-muted)',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius-md)',
            fontSize: 'var(--font-size-sm)',
            cursor: 'pointer',
            transition: 'var(--transition-fast)',
            whiteSpace: 'nowrap',
          }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
};

export default Header;
